import { render, staticRenderFns } from "./RightPanelModuleStyle.vue?vue&type=template&id=15b05ee5&scoped=true"
import script from "./RightPanelModuleStyle.vue?vue&type=script&lang=js"
export * from "./RightPanelModuleStyle.vue?vue&type=script&lang=js"
import style0 from "./RightPanelModuleStyle.vue?vue&type=style&index=0&id=15b05ee5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b05ee5",
  null
  
)

export default component.exports